import dayjs, { Dayjs, OpUnitType, QUnitType } from 'dayjs'
import ru from 'dayjs/locale/ru'
import rTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

dayjs.extend(advancedFormat)
dayjs.extend(quarterOfYear)
dayjs.extend(rTime)
dayjs.extend(utc)
dayjs.locale(ru)

export const dateFormat = (date?: string) => {
  if (!date) return

  return dayjs(date).format('DD.MM.YYYY')
}

export const dateFormatRequest = (date: Dayjs) => {
  return date.format('YYYY-MM-DD')
}

export const relativeTime = (date: string | Date) => {
  return dayjs().to(dayjs(date))
}

export const diffDate = (
  start: string | Date,
  end: string | Date,
  unit?: OpUnitType | QUnitType
) => {
  return dayjs(end).diff(dayjs(start), unit)
}

export const diffDateToNow = (
  date: string | Date | dayjs.Dayjs,
  suffix?: boolean
) => {
  return dayjs(date).toNow(suffix)
}

export const isWeekend = (date: string | Date | dayjs.Dayjs) =>
  dayjs(date).day() === 0 || dayjs(date).day() === 6

export const format = {
  quarter: 'Q',
  weekdayMin: 'dd',
  dayOfMonth: 'D',
  month: 'MMMM',
  normalDateShort: 'D MMM',
  shortFullTime: 'HH:mm:ss',
  shortFullDate: 'DD.MM.YYYY',
  requestShortFullDate: 'YYYY-MM-DD',
  fullDateWithShortTime: 'DD.MM.YYYY hh:mm'
} as const

export const dateFormatMask = (
  date: string | Date | dayjs.Dayjs,
  format: string
) => {
  return dayjs(date).format(format)
}

export const daysInMonth = (date: string | Date | dayjs.Dayjs) =>
  dayjs(date).daysInMonth()

export const addDate = (
  date: string | Date | dayjs.Dayjs,
  value: number,
  unit: OpUnitType | QUnitType,
  startOfUnit?: OpUnitType | QUnitType
) => {
  if (startOfUnit) {
    return (
      dayjs(date)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .startOf(startOfUnit as any)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .add(value, unit as any)
    )
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return dayjs(date).add(value, unit as any)
}

export const subtractDate = (
  date: string | Date | dayjs.Dayjs,
  value: number,
  unit: QUnitType
) => {
  return dayjs(date).subtract(value, unit)
}

export const isValidDate = (date?: string | null | Date | Dayjs) => {
  if (!date) {
    return
  }

  return dayjs(date).isValid()
}
